import {useEffect} from 'react'
import {useParams, useNavigate} from 'react-router-dom'
import {ROUTES} from '../../../../_gori/constants'
import {useVerifyHash} from '../hooks'
import {useIntl} from 'react-intl'

export function GoriSignatureScan() {
  const {hash} = useParams<{hash: string}>()
  const navigate = useNavigate()
  const intl = useIntl()
  const {data, isLoading, isError} = useVerifyHash(hash)

  useEffect(() => {
    if (isLoading || !hash) return

    if (isError) {
      // Redirect to verification page to show fraud alert, not back to manual entry
      navigate(ROUTES.GORI_SIGNATURE.HASH.replace(':hash', hash), {
        state: {from: 'scan'},
      })
      return
    }

    if (!data?.valid) {
      const errorMessage = data?.error || ''
      if (errorMessage.includes('expired') || errorMessage.includes('no longer be used')) {
        navigate(ROUTES.GORI_SIGNATURE.METHOD_SELECT, {
          state: {hash: hash},
        })
      } else {
        navigate(ROUTES.GORI_SIGNATURE.HASH.replace(':hash', hash), {
          state: {from: 'scan'},
        })
      }
      return
    }

    navigate(ROUTES.GORI_SIGNATURE.METHOD_SELECT, {
      state: {hash: hash},
    })
  }, [isLoading, isError, data, hash, navigate])

  if (isLoading) {
    return (
      <div className='gori-signature-results d-flex align-items-center justify-content-center'>
        <div className='text-center'>
          <img
            src='/media/gori/gori-signature/reload.svg'
            alt='Loading'
            style={{width: '80px', height: '80px', animation: 'spin 2s linear infinite'}}
          />
          <p className='fs-4 text-dark mt-4'>
            {intl.formatMessage({id: 'GORI_SIGNATURE_LOADING'})}
          </p>
        </div>
      </div>
    )
  }

  return <div />
}
